"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TemplateTabs = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _TemplateTabs = require("./TemplateTabs.styled");
var _Tabs = require("../../constants/Tabs");
var TemplateTabs = exports.TemplateTabs = function TemplateTabs(_ref) {
  var onTabChanged = _ref.onTabChanged,
    currentTab = _ref.currentTab;
  var tabs = [_Tabs.TEMPLATE, _Tabs.EVENT];
  var getEventTitle = function getEventTitle(tab) {
    if (tab === _Tabs.EVENT) {
      return 'Event content';
    }
    return tab;
  };
  return /*#__PURE__*/_react["default"].createElement(_TemplateTabs.TabsContainer, null, tabs.map(function (tab) {
    return /*#__PURE__*/_react["default"].createElement(_TemplateTabs.Tab, {
      "data-testid": tab,
      key: tab,
      isActive: currentTab === tab,
      onClick: function onClick() {
        return onTabChanged(tab);
      }
    }, getEventTitle(tab));
  }));
};
TemplateTabs.propTypes = {
  currentTab: _propTypes["default"].string,
  onTabChanged: _propTypes["default"].func
};
var _default = exports["default"] = TemplateTabs;